<template>
  <div ref="chartHandler" class="h-full w-full z-0">
    <canvas ref="myChart" id="myChart" width="100%" height="100%"></canvas>
  </div>
  <DataTable />
</template>

<script>
import { Chart, registerables } from 'chart.js'
import DataTable from '@/components/DataTable'
import { provide, reactive } from 'vue'

export default {
  name: 'MLPlayground',
  components: { DataTable },
  data: function () {
    return {
      points: []
    }
  },
  setup: function () {
    const datasets = reactive([])
    const addDataset = (title) => {
      console.log(datasets)
      datasets.push(title)
      console.log(datasets)
    }
    provide('datasets', datasets)
    provide('addDataset', addDataset)
    return {
      datasets
    }
  },
  created: function () {
    window.addEventListener('resize', this.myEventHandler)
  },
  unmounted: function () {
    window.addEventListener('resize', this.myEventHandler)
  },
  mounted: function () {
    Chart.register(...registerables)
    console.log(this.$refs.myChart)
    const ctx = (this.$refs.myChart).getContext('2d')
    // const ctx = document.getElementById('myChart').getContext('2d')
    const labels = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June'
    ]
    const data = {
      labels: labels,
      datasets: [{
        label: 'My First dataset',
        backgroundColor: 'rgb(255, 99, 132)',
        borderColor: 'rgb(255, 99, 132)',
        data: [0, 10, 5, 2, 20, 30, 45]
      }]
    }
    const config = {
      type: 'line',
      data: data,
      options: {}
    }
    /* eslint-disable no-new */
    new Chart(
      ctx,
      config
    )
  },
  methods: {
    addPoints: function () {
      this.points.push([1, 1])
      console.log('Pushed: 1, 1')
    }
  }
}
</script>

<style scoped>

</style>
